<nav class="offcanvas offcanvas-start nav-sidebar" tabindex="-1" id="sidebar" *ngIf="actualUser">
    <section>
        <header>
        </header>
        <ng-template #loadingProfilePhoto>
        </ng-template>
        <main class="nav__sidebar__content">
            <div class="item-user" >
                <div class="item-user-img">
                    <ng-template #notShowProfile>{{pessoa?.name | codeName}}</ng-template>
                    <div *ngIf="imagem?.length > 40; else notShowProfile">
                        <img [src]="imagem" onError="this.src = '../../../../assets/img/jpg/no-user.jpg'" alt="" style="width: 2.25rem; height: 2.25rem;padding: 0.1em;
                           ">
                    </div>
                </div>
                <section>
                    <p>{{pessoa?.name | nome}}</p>
                    <p *ngIf="!pessoa">Carregando...</p>
                </section>
            </div>
            <nav>
                <ul>
                    <li [routerLink]="['/home']" routerLinkActive="active" (click)="toggleDropdown('home')">
                        <div (click)="desativarFundo()">
                            <fa-icon [icon]="faHouse" class="icone__menu"></fa-icon>
                            <span class="item-menu link-menu" translate="no">
                                Home
                            </span>
                        </div>
                    </li>
                </ul>
                <ul *ngIf="pdv()">
                    <li [routerLink]="['/pdv']" routerLinkActive="active" (click)="toggleDropdown('pdv')">
                        <div (click)="desativarFundo()">
                            <fa-icon [icon]="faHandshake" class="icone__menu"></fa-icon>
                            <span class="item-menu link-menu" translate="no">
                                Programa de Demissão Voluntária
                            </span>
                        </div>
                    </li>
                </ul>
                <ul *ngIf="actualUser.healthProfile">
                    <li data-bs-toggle="collapse" href="#saude" role="button" aria-expanded="false"
                        aria-controls="collapseExample" id="dropwdown__saude" (click)="toggleDropdown('saude')">
                        <div>
                            <fa-icon [icon]="faHeartPulse" class="icone__menu"></fa-icon>
                            <span class="item-menu">Saúde</span>
                        </div>
                        <span><fa-icon [icon]="faAngleDown"></fa-icon></span>
                    </li>
                    <ul class="collapse dropdown-item" id="saude">
                        <li [routerLink]="['/dashboard-saude']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()"
                            *ngIf="actualUser.healthProfile.statusId == beneficiaryType.ATIVO">
                            <a class="link-menu">Painel de Saúde</a>
                        </li>
                        <li [routerLink]="['/adesao-saude']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()"
                            *ngIf="actualUser.healthProfile.statusId == beneficiaryType.ATIVO">
                            <a class="link-menu">Adesão Plano de Saúde</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/extrato-financeiro']" routerLinkActive="active" class="item"
                            *ngIf='actualUser.healthProfile.statusId == beneficiaryType.ATIVO'
                            (click)="desativarFundo()">
                            <a class="link-menu">Extrato Financeiro</a>
                        </li>
                        <li [routerLink]="['/historico-utilizacao']" routerLinkActive="active"
                            class="link__individual item" (click)="desativarFundo()">
                            <a class="link-menu">Histórico de Utilização</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/cancelar']" routerLinkActive="active" class="item"
                            *ngIf="actualUser.healthProfile.statusId == beneficiaryType.ATIVO"
                            (click)="desativarFundo()">
                            <a class="link-menu">Cancelar Plano de Saúde</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/excluir']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()" *ngIf="actualUser.healthProfile.statusId == beneficiaryType.ATIVO
                            && actualUser.healthProfile.hasDependants">
                            <a class="link-menu">Excluir Dependentes do Plano</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/cartao-digital']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()">
                            <a class="link-menu">Cartão Digital</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/checkup']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()">
                            <a class="link-menu">Programa de Avaliação Médica</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/historico-liberacao']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()">
                            <a class="link-menu">Minhas Liberações</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/reembolso']" routerLinkActive="active" class="item"
                            *ngIf='actualUser.healthProfile.statusId == beneficiaryType.ATIVO'
                            (click)="desativarFundo()">
                            <a class="link-menu">Reembolso</a>
                        </li>
                        <hr class="dropdown__divider__item__menu" *ngIf="false">
                        <li [routerLink]="['/solicitar-declaracao']" [queryParams]="{ productId: product.SAUDE }"
                            routerLinkActive="active" class="item"
                            *ngIf='actualUser.healthProfile.statusId == beneficiaryType.ATIVO'
                            (click)="desativarFundo()">
                            <a class="link-menu">Solicitação de Declaração</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/rede-credenciada']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()">
                            <a class="link-menu">Rede Credenciada</a>
                        </li>
                    </ul>
                </ul>
                <ul *ngIf="actualUser.socialSecurityProfile">
                    <li data-bs-toggle="collapse" href="#previdencia" id="dropwdown__previdencia" role="button"
                        aria-expanded="false" aria-controls="collapseExample" routerLinkActive="active"
                        (click)="toggleDropdown('previdencia')">
                        <div>
                            <fa-icon [icon]="faSackDollar" class="icone__menu"></fa-icon>
                            <span class="item-menu">Previdência</span>
                        </div>
                        <span><fa-icon [icon]="faAngleDown"></fa-icon></span>
                    </li>
                    <ul class="collapse dropdown-item" id="previdencia">
                        <li [routerLink]="['/dashboard-previdencia']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()"
                            *ngIf="actualUser.socialSecurityProfile?.statusId != beneficiaryType.DESLIGADO">
                            <a class="link-menu">Painel de Previdência</a>
                        </li>
                        <li [routerLink]="['/resgate-reserva']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()" *ngIf="this.actualUser.socialSecurityProfile.id == 3 &&
                                (actualUser.socialSecurityProfile?.statusId != beneficiaryType.ASSISTIDO &&
                                actualUser.socialSecurityProfile?.statusId != beneficiaryType.PENSAO_MORTE &&
                                actualUser.socialSecurityProfile?.statusId != beneficiaryType.PENSAO_MORTE_TUTOR)">
                            <a class="link-menu">Simulação de Resgate</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/pagamentos']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()" *ngIf="(actualUser.socialSecurityProfile?.statusId == beneficiaryType.ASSISTIDO
                            || actualUser.socialSecurityProfile?.statusId == beneficiaryType.PENSAO_MORTE 
                            || actualUser.socialSecurityProfile?.statusId == beneficiaryType.PENSAO_MORTE_TUTOR)">
                            <a>Análise de Pagamento</a>
                        </li>
                        <hr class="dropdown__divider__item__menu" *ngIf="(actualUser.socialSecurityProfile?.statusId == beneficiaryType.ASSISTIDO 
                            || actualUser.socialSecurityProfile?.statusId == beneficiaryType.PENSAO_MORTE
                            || actualUser.socialSecurityProfile?.statusId == beneficiaryType.PENSAO_MORTE_TUTOR)">
                        <li [routerLink]="['/solicitacao-declaracao-ppe']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()">
                            <a class="link-menu">Declaração PPE</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/simulador-previdencia']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()" *ngIf="this.actualUser.socialSecurityProfile.id == 3 && 
                            (actualUser.socialSecurityProfile?.statusId == beneficiaryType.ATIVO 
                            || actualUser.socialSecurityProfile?.statusId == beneficiaryType.AUTOPATROCINADO 
                            || actualUser.socialSecurityProfile?.statusId == beneficiaryType.VINCULADO)">
                            <a class="link-menu">Simulação de Previdência</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <!-- <li [routerLink]="['/minhas-solicitacoes-aporte']"
                            [queryParams]="{ productId: product.PREVIDENCIA}" routerLinkActive="active"
                            class="link__individual item" (click)="desativarFundo()"
                            *ngIf="actualUser.socialSecurityProfile?.statusId != beneficiaryType.DESLIGADO">
                            <a class="link-menu">Histórico de Aportes</a>
                        </li> -->
                        <li [routerLink]="['/solicitacao-de-aporte']" [queryParams]="{ productId: product.PREVIDENCIA}"
                            routerLinkActive="active" class="link__individual item" (click)="desativarFundo()" *ngIf="(actualUser.socialSecurityProfile.statusId == beneficiaryType.ATIVO
                            || actualUser.socialSecurityProfile.statusId == beneficiaryType.AUTOPATROCINADO
                            || actualUser.socialSecurityProfile.statusId == beneficiaryType.VINCULADO)">
                            <a class="link-menu">Aporte</a>
                        </li>
                        <li [routerLink]="['/minhas-solicitacoes-de-contribuicao']"
                            [queryParams]="{ productId: product.PREVIDENCIA}" routerLinkActive="active"
                            class="link__individual item" (click)="desativarFundo()"
                            *ngIf="actualUser.socialSecurityProfile?.statusId != beneficiaryType.DESLIGADO">
                            <a class="link-menu">Histórico de Contribuições</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <!-- <li [routerLink]="['/solicitacao-beneficio']" routerLinkActive="active" class="item" 
                            *ngIf="actualUser.socialSecurityProfile?.statusId == beneficiaryType.ATIVO || 
                                actualUser.socialSecurityProfile?.statusId == beneficiaryType.AUTOPATROCINADO ||
                                actualUser.socialSecurityProfile?.statusId == beneficiaryType.VINCULADO)">   
                                    <a class="link-menu">Solicitação de Benefício</a> 
                                </li> -->
                        <li [routerLink]="['/solicitar-declaracao']" [queryParams]="{ productId: product.PREVIDENCIA}"
                            routerLinkActive="active" class="link__individual item" (click)="desativarFundo()"
                            *ngIf="actualUser.socialSecurityProfile?.statusId != beneficiaryType.DESLIGADO">
                            <a class="link-menu">Solicitação de Declaração</a>
                        </li>
                        <hr class="dropdown__divider__item__menu" *ngIf="actualUser?.socialSecurityProfile?.id == 4">
                        <li [routerLink]="['/simulacao-plano-iv']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()" *ngIf="actualUser?.socialSecurityProfile?.id == 4">
                            <a class="link-menu">Simulação Plano IV</a>
                        </li>
                    </ul>
                </ul>
                <ul *ngIf="pessoa?.name != 'Usuario Teste'">
                    <li data-bs-toggle="collapse" id="dropwdown__emprestimo" href="#emprestimo" role="button"
                        aria-expanded="false" aria-controls="collapseExample" (click)="toggleDropdown('emprestimo')">
                        <div>
                            <fa-icon [icon]="faHandHoldingDollar" class="icone__menu"></fa-icon>
                            <span class="item-menu">Empréstimos</span>
                        </div>
                        <span>
                            <fa-icon [icon]="faAngleDown"></fa-icon>
                        </span>
                    </li>
                    <ul class="collapse dropdown-item" id="emprestimo">
                        <li [routerLink]="['/meus-emprestimos']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()">
                            <a class="link-menu">Histórico</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/solicitacao-emprestimo']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()" *ngIf='isLoanProfile'>
                            <a class="link-menu">Simular</a>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/solicitacao-de-boleto']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()" *ngIf="permissaoBoleto != false">
                            <a class="link-menu">Solicitação de Boleto</a>
                        </li>
                    </ul>
                </ul>
                <ul
                    *ngIf="((actualUser.healthProfile && actualUser.healthProfile.statusId != beneficiaryType.DEPENDENTE) || actualUser.socialSecurityProfile)">
                    <li [routerLink]="['/boleto']" routerLinkActive="active" class="item" (click)="desativarFundo()">
                        <a class="link-menu">
                            <fa-icon [icon]="faBarcode" class="icone__menu"></fa-icon>
                            <span class="item-menu">
                                Boletos
                            </span></a>
                    </li>
                </ul>
                <ul *ngIf="peculio()">
                    <li data-bs-toggle="collapse" id="dropwdown__peculio" href="#peculio" aria-expanded="false"
                        aria-controls="collapseExample" (click)="toggleDropdown('peculio')">
                        <div>
                            <fa-icon [icon]="faShieldHeart" class="icone__menu"></fa-icon>
                            <span class="item-menu">
                                Pecúlio
                            </span>
                        </div>
                        <span>
                            <fa-icon [icon]="faAngleDown"></fa-icon>
                        </span>
                    </li>
                    <ul class="collapse dropdown-item" id="peculio">
                        <li [routerLink]="['/peculio']" routerLinkActive="active" id="peculio">
                            <div>
                                <span class="item-menu">Meu Plano Pecúlio</span>
                            </div>
                        </li>
                        <hr class="dropdown__divider__item__menu">
                        <li [routerLink]="['/solicitar-peculio']" routerLinkActive="active" class="item"
                            (click)="desativarFundo()">
                            <a class="link-menu">Novo Pecúlio</a>
                        </li>
                    </ul>
                </ul>
                <!-- <ul (click)="closeAllDropdowns()" *ngIf="peculio()">
                    <li [routerLink]="['/peculio']" routerLinkActive="active" id="peculio"
                        (click)="toggleDropdown('peculio')">
                        <div (click)="closeAllDropdowns()">
                            <fa-icon [icon]="faShieldHeart" class="icone__menu"></fa-icon>
                            <span class="item-menu">
                                Pecúlio
                            </span>
                        </div>
                    </li>
                </ul> -->
                <ul (click)="toggleDropdown('dadosCadastrais')">
                    <li [routerLink]="['/dados-cadastrais']" routerLinkActive="active" id="dadosCadastrais"
                        (click)="desativarFundo()">
                        <span>
                            <fa-icon [icon]="faUser" class="icone__menu"></fa-icon>
                            <span class="item-menu link-menu"> Dados Cadastrais</span>
                        </span>
                    </li>
                </ul>
                <ul (click)="toggleDropdown('informeRendimentos')"
                    *ngIf="actualUser.socialSecurityProfile?.id != beneficiaryType.DEPENDENTE">
                    <li [routerLink]="['/informe-rendimentos']" routerLinkActive="active" id="informeRendimentos"
                        (click)="desativarFundo()">
                        <div>
                            <fa-icon [icon]="faCoins" class="icone__menu"></fa-icon>
                            <span class="item-menu link-menu">Informe de Rendimentos</span>
                        </div>
                    </li>
                </ul>
                <ul (click)="toggleDropdown('notificacoes')">
                    <li [routerLink]="['/notificacao']" routerLinkActive="active" id="notificacoes"
                        (click)="desativarFundo()">
                        <div>
                            <fa-icon [icon]="faBell" class="icone__menu"></fa-icon>
                            <span class="item-menu link-menu"> Notificações</span>
                            <span class="badge bg-danger"
                                *ngIf="notificacoes && notificacoes.length > 0">{{notificacoes.length}}</span>
                        </div>
                    </li>
                </ul>
                <ul (click)="toggleDropdown('atas')">
                    <li [routerLink]="['/atas']" routerLinkActive="active" id="notificacoes" (click)="desativarFundo()">
                        <div>
                            <fa-icon [icon]="faFolderOpen" class="icone__menu"></fa-icon>
                            <span class="item-menu link-menu">
                                Atas
                            </span>
                        </div>
                    </li>
                </ul>
                <ul (click)="toggleDropdown('minhasSolicitacoes')">
                    <li [routerLink]="['/minhas-solicitacoes']" routerLinkActive="active" id="notificacoes"
                        (click)="desativarFundo()">
                        <div>
                            <fa-icon [icon]="faInbox" class="icone__menu"></fa-icon>
                            <span class="item-menu link-menu">
                                Minhas Solicitações
                            </span>
                        </div>
                    </li>
                </ul>
                <ul (click)="toggleDropdown('notificacoes')">
                    <li [routerLink]="['/contatos']" routerLinkActive="active" id="notificacoes"
                        (click)="desativarFundo()">
                        <div>
                            <fa-icon [icon]="faPhone" class="icone__menu"></fa-icon>
                            <span class="item-menu link-menu">
                                Fale Conosco
                            </span>
                        </div>
                    </li>
                </ul>
                <!-- <ul>
                        <li  
                            [routerLink]="['/contatos']" 
                            routerLinkActive="active"
                            id="notificacoes" 
                            (click)="toggleDropdown('notificacoes')">
                            <div> 
                                <fa-icon [icon]="faQuestion" class="icone__menu"></fa-icon>
                                <span class="item-menu">
                                    Perguntas Frequentes
                                </span>                                
                            </div>
                        </li>
                    </ul> -->
                <hr class="dropdown__divider__menu">
                <ul (click)="desativarFundo()">
                    <li (click)="logout()">
                        <div (click)="logout()">
                            <fa-icon [icon]="faRightFromBracket" class="icone__menu"></fa-icon>
                            <span class="item-menu link-menu">
                                Sair
                            </span>
                        </div>
                    </li>
                </ul>
            </nav>
        </main>
    </section>
    <footer class="content__sidebar__footer">
    </footer>
</nav>